import { render } from "./Lingua.vue?vue&type=template&id=761d71ec&scoped=true"
import script from "./Lingua.vue?vue&type=script&lang=js"
export * from "./Lingua.vue?vue&type=script&lang=js"

import "./Lingua.vue?vue&type=style&index=0&id=761d71ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-761d71ec"]])

export default __exports__